export default __webpack_public_path__ + "static/media/ICON.d39921ac.ico";